import { render } from "./RightPanelButtons.vue?vue&type=template&id=38b6da60&scoped=true"
const script = {}

import "./RightPanelButtons.vue?vue&type=style&index=0&id=38b6da60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b6da60"]])

export default __exports__